import React from "react";
import { compose } from "redux";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { getMapData, makeGetAlertsData } from "../../../../selectors/farmMapSelector";
import ErrorList from "./ErrorList";
import WarningList from "./WarningList";
import DeviceControlPanel from "../device-controls/DeviceControlPanel";
import { getAddressString, getAlias } from "../../../../utils/DevicesUtils";

function LightContent({
    device,
    index,
    t,
    expanded,
    toggleExpand,
    alerts: { errors, isErrorInChildren, warnings, isWarningInChildren }
}) {
    if (!device) return null;
    const classNames = ["map-drawer"];
    if (expanded) classNames.push("expanded");
    return (
        <div className={classNames.join(" ")}>
            <div className={"toggle-expand"} aria-label={expanded ? t("collapse") : t("animalDocuments.expand")}
                onClick={toggleExpand} />
            <div className={"map-drawer-content"}>
                <div className={"map-drawer-header"}>
                    <div>{t("newSettings.buildings.farmMap.groups.lights")} - {getAlias(device, index)}</div>
                    <div>{`(${getAddressString(device, index)})`}</div>
                </div>
                {
                    !!device &&
                    <DeviceControlPanel placementId={null} devices={[{ device, index }]} />
                }
                <ErrorList t={t} errors={errors} isErrorInChildren={isErrorInChildren} />
                <WarningList t={t} warnings={warnings} isWarningInChildren={isWarningInChildren} />
            </div>
        </div>
    );
}


const emptyObject = {};

const makeMapStateToProps = () => {
    return (state, props) => {
        const getAlertsData = makeGetAlertsData();
        return {
            data: getMapData(state)[props.device.DevID] || emptyObject,
            alerts: getAlertsData(state, props.selectedId, "devices")
        };
    };
}

export default compose(
    withTranslation(),
    connect(makeMapStateToProps)
)(LightContent)
